import {ref, watch, computed} from '@vue/composition-api'
import store from '@/store'
import {title} from '@core/utils/filter'

// Notification
import {useToast} from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function approvalList() {
    // Use toast
    const toast = useToast()

    const refListTable = ref(null)

    // Table Handlers
    const tableColumns = [
        {key: 'actions', label: 'Aksi', sortable: false},
        {key: 'tanggal_mulai', label: 'Tanggal Mulai', sortable: true},
        // {key: 'tanggal_selesai', label: 'Tanggal Selesai', sortable: true},
        {key: 'nama', label: 'Nama Pegawai', sortable: true},
        // {key: 'nip', label: 'Nip Pegawai', sortable: true},
        {key: 'tipe', label: 'Jenis', sortable: true},
        {key: 'evidence', label: 'Bukti Foto', sortable: false},
        // {key: 'keterangan', label: 'Keterangan', sortable: true},
        {key: 'status', label: 'status', sortable: true},
        {key: 'status_keterangan', label: 'Keterangan status', sortable: false},
    ]

    const perPage = ref(10)
    const total = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('status')
    const isSortDirDesc = ref(true)
    const statusFilter = ref(null)
    const tipeFilter = ref(null)
    const pengawasId = ref(null)

    const dataMeta = computed(() => {
        const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: total.value,
        }
    })

    const refetchData = () => {
        refListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, statusFilter, tipeFilter, pengawasId], () => {
        refetchData()
    })

    const fetch = (ctx, callback) => {
        console.log(pengawasId)
        store
            .dispatch('app-approval/list', {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
                status: statusFilter.value,
                tipe: tipeFilter.value,
                pengawas : pengawasId.value
            })
            .then(response => {
                const data = response.data.data.data
                const totalData = response.data.data.total

                callback(data)
                total.value = totalData
            })
            .catch((error) => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error fetching list',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }


    // *===============================================---*
    // *--------- UI ---------------------------------------*
    // *===============================================---*
    const resolveStatusVariantLabel = status => {
        if (status === 'waiting') return 'Menunggu'
        if (status === 'approved') return 'Disetujui'
        if (status === 'rejected') return 'Ditolak'
        return 'Menunggu'
    }

    const resolveTipeVariantLabel = tipe => {
        if (tipe === 'izin') return 'Izin'
        if (tipe === 'dinas') return 'Dinas Keluar'
        if (tipe === 'wfh') return 'Work From Home'
        return 'Sakit'
    }

    return {
        fetch,
        tableColumns,
        perPage,
        currentPage,
        total,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refListTable,
        resolveStatusVariantLabel,
        resolveTipeVariantLabel,

        refetchData,

        //Extra Filter
        statusFilter,
        tipeFilter,
        pengawasId
    }
}
